
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class FranchiseeProductsDialog extends Serenity.EntityDialog<FranchiseeProductsRow, any> {
        protected getFormKey() { return FranchiseeProductsForm.formKey; }
        protected getIdProperty() { return FranchiseeProductsRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseeProductsRow.localTextPrefix; }
        protected getNameProperty() { return FranchiseeProductsRow.nameProperty; }
        protected getService() { return FranchiseeProductsService.baseUrl; }
        protected getDeletePermission() { return FranchiseeProductsRow.deletePermission; }
        protected getInsertPermission() { return FranchiseeProductsRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseeProductsRow.updatePermission; }

        protected form = new FranchiseeProductsForm(this.idPrefix);

    }
}